import React, { useEffect } from "react";

const BottomDrawer = ({ isAnon, parsedPrediction, signIn, setPopupOpen }) => {
  useEffect(() => {
    console.log("BottomDrawer rendered with:", {
      isAnon,
      hasParsedPrediction: !!parsedPrediction,
      hasSignIn: !!signIn,
    });
  }, [isAnon, parsedPrediction, signIn]);

  return (
    <>
      {!isAnon && setPopupOpen && (
        <div className="overlay-content" 
              style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "270px" }}>
          <button
            className="sign-in-button"
            style={{ justifyContent: "center" }}
            onClick={() => setPopupOpen(true)}
          >
            Upgrade Today
          </button>
          <p className="sign-up-text" style={{ textAlign: "center" }}>
            Upgrade to a paid plan and continue accessing premium AI insights
            tailored to your trading needs.
            <br />
            <br />
            <b>No commitments, cancel anytime.</b>
          </p>
        </div>
      )}
      {isAnon && parsedPrediction && signIn && (
        <div className="overlay-content">
          <button
            className="sign-in-button"
            onClick={signIn}
            style={{ justifyContent: "center", minWidth: "auto" }}
          >
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt="Google Icon"
              className="google-icon"
            />
            Continue With Google
          </button>
          <p className="sign-up-text" style={{ textAlign: "center" }}>
            Our deep-learning model analyzed{" "}
            {parsedPrediction?.data_points ?? "100K+"} data points since{" "}
            {parsedPrediction?.first_trade_date ? (
              <strong>{parsedPrediction.first_trade_date}</strong>
            ) : (
              "inception"
            )}{" "}
            for{" "}
            {parsedPrediction?.ticker ? (
              <strong style={{ fontStyle: "normal" }}>
                {parsedPrediction.ticker}
              </strong>
            ) : (
              "the ticker"
            )}
            .<br />
            <br />
            Your information stays private.
          </p>
          <p className="sign-up-text-ps" style={{ textAlign: "center" }}>
            By continuing, you agree to MarketCrunchAI's{" "}
            <b>Privacy Policy</b> and <b>Terms of Service</b> (see footer).
          </p>
        </div>
      )}
    </>
  );
};

export default BottomDrawer;
